/* ========================================================================
   One Good Blog — listing + article behaviour
   ======================================================================== */
(function () {
  function normalise(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function initArticleToc(root) {
    var body = root.querySelector('.ogb-article-body');
    var toc = root.querySelector('.ogb-toc');

    if (!body || !toc || toc.dataset.ogbTocReady === '1') return;
    toc.dataset.ogbTocReady = '1';

    var list = toc.querySelector('ul') || document.createElement('ul');
    if (!list.parentNode) toc.appendChild(list);
    list.innerHTML = '';

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));

    if (headings.length < 2) {
      toc.style.display = 'none';
      return;
    }

    headings.forEach(function (h, i) {
      if (!h.id) {
        h.id = (h.textContent || 'section-' + i)
          .toLowerCase()
          .replace(/[^\w\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-') || 'section-' + i;
      }

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });

    var links = Array.prototype.slice.call(list.querySelectorAll('a'));
    var onScroll = function () {
      var pos = window.scrollY + 120;
      var activeIndex = 0;
      headings.forEach(function (h, i) {
        if (h.offsetTop <= pos) activeIndex = i;
      });
      links.forEach(function (a, i) {
        a.classList.toggle('is-active', i === activeIndex);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function filterBlog(form) {
    var root = form.closest('.ogb') || document;
    var input = form.querySelector('input[type="search"]');
    var grid = root.querySelector('[data-ogb-grid]');
    if (!grid) return;

    var query = input ? normalise(input.value) : '';
    var activeChip = root.querySelector('[data-ogb-filter].is-active');
    var activeTag = activeChip ? normalise(activeChip.getAttribute('data-ogb-filter')) : 'all';

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ogb-card]'));
    var noResults = root.querySelector('[data-ogb-no-results]');
    var pagination = root.querySelector('.ogb-pagination');
    var visibleCount = 0;

    cards.forEach(function (card) {
      var haystack = normalise(card.getAttribute('data-ogb-search') || card.textContent);
      var rawTags = card.getAttribute('data-ogb-tags') || '';
      var tags = rawTags.split('||').map(function (tag) {
        return normalise(tag);
      });

      var matchedSearch = !query || haystack.indexOf(query) !== -1;
      var matchedTag = activeTag === 'all' || tags.indexOf(activeTag) !== -1;
      var matched = matchedSearch && matchedTag;

      card.hidden = !matched;
      card.style.display = matched ? '' : 'none';

      if (matched) visibleCount += 1;
    });

    if (noResults) noResults.hidden = visibleCount > 0;
    if (pagination) pagination.hidden = activeTag !== 'all' || !!query;
  }

  function initBlogFilters(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ogb-filter]'));
    if (!chips.length) return;

    chips.forEach(function (chip) {
      if (chip.dataset.ogbFilterReady === '1') return;
      chip.dataset.ogbFilterReady = '1';

      chip.addEventListener('click', function () {
        var blogRoot = chip.closest('.ogb') || document;
        var form = blogRoot.querySelector('[data-ogb-live-search]');

        chips.forEach(function (item) {
          item.classList.remove('is-active');
        });

        chip.classList.add('is-active');

        if (form) filterBlog(form);
      });
    });
  }

  function initBlogSearch(root) {
    var forms = Array.prototype.slice.call(root.querySelectorAll('[data-ogb-live-search]'));

    forms.forEach(function (form) {
      if (form.dataset.ogbSearchReady === '1') return;
      form.dataset.ogbSearchReady = '1';

      var input = form.querySelector('input[type="search"]');
      if (!input) return;

      // Stop Enter from going to Shopify's global search page.
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        filterBlog(form);
      });

      // Live-filter as the user types, clears, pastes, or uses mobile keyboard input.
      ['input', 'keyup', 'search', 'change', 'paste'].forEach(function (eventName) {
        input.addEventListener(eventName, function () {
          window.requestAnimationFrame(function () {
            filterBlog(form);
          });
        });
      });

      filterBlog(form);
    });
  }

  function initCopyLink(root) {
    var copyBtn = root.querySelector('#ogbCopyLink');
    if (!copyBtn || copyBtn.dataset.ogbCopyReady === '1') return;
    copyBtn.dataset.ogbCopyReady = '1';

    copyBtn.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(window.location.href);
      var original = copyBtn.innerHTML;
      copyBtn.innerHTML = '✓';
      setTimeout(function () { copyBtn.innerHTML = original; }, 1400);
    });
  }

  function init(root) {
    root = root || document;
    initBlogSearch(root);
    initBlogFilters(root);
    initArticleToc(root);
    initCopyLink(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor / dynamically rendered sections support.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
